(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pcol-card"] && !Shopify.designMode) return;
  try {
    /* Wishlist heart toggle for every grid except the collection page (it has its own handler). */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.pcc-heart');
    if (!heart || heart.closest('.pcol')) return;
    heart.setAttribute('aria-pressed', String(heart.getAttribute('aria-pressed') !== 'true'));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__qvInit) return; window.__qvInit = 1;
    var dlg, body, cache = {}, cur = null, sel = [], card = null, handle = null;
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var cur_code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var money = function (c) {
      var v = c / 100;
      try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur_code, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
      catch (e) { return '₹' + v; }
    };
    var img = function (u, w) { if (!u) return ''; var s = u.indexOf('//') === 0 ? 'https:' + u : u; return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + (/\.heic(\?|$)/i.test(s) ? '&format=jpg' : ''); };
    var base = function (u) { return String(u || '').replace(/^https?:/, '').split('?')[0]; };

    var ensure = function () {
      if (dlg) return;
      dlg = document.createElement('dialog'); dlg.className = 'qvd'; dlg.setAttribute('aria-label', 'Quick view');
      dlg.innerHTML = '<div class="qvd__sheet"><button type="button" class="qvd__x" data-qv-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="qvd__body"></div></div>';
      document.body.appendChild(dlg); body = dlg.querySelector('.qvd__body');
      dlg.addEventListener('click', onClick);
      body.addEventListener('scroll', function (e) {
        var t = e.target; if (!t.classList || !t.classList.contains('qvd__track')) return;
        var k = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        [].forEach.call(body.querySelectorAll('.qvd__dots i'), function (d, i) { d.classList.toggle('is-on', i === k); });
      }, true);
    };

    var variantFor = function () {
      return cur.variants.filter(function (v) { return sel.every(function (s, i) { return v['option' + (i + 1)] === s; }); })[0] || null;
    };
    var optNames = function () {
      return (cur.options || []).map(function (o) { return typeof o === 'string' ? { name: o, values: [] } : o; });
    };
    var optValues = function (i, o) {
      if (o.values && o.values.length) return o.values;
      var seen = [], k = 'option' + (i + 1);
      cur.variants.forEach(function (v) { if (seen.indexOf(v[k]) < 0) seen.push(v[k]); });
      return seen;
    };

    var desc = function (html) {
      var d = new DOMParser().parseFromString(html || '', 'text/html'), out = [];
      [].forEach.call(d.body.querySelectorAll('p, li, h1, h2, h3, h4'), function (n) {
        var t = (n.textContent || '').replace(/\s+/g, ' ').trim(); if (t) out.push((n.tagName === 'LI' ? '• ' : '') + t);
      });
      if (!out.length) { var t = (d.body.textContent || '').replace(/\s+/g, ' ').trim(); if (t) out.push(t); }
      return out.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('');
    };

    var render = function (keepGal) {
      var p = cur, v = variantFor(), imgs = (p.images || []).slice(0, 10);
      if (!imgs.length && p.featured_image) imgs = [p.featured_image];
      var names = optNames(), opts = '';
      if (p.variants.length > 1) {
        opts = names.map(function (o, i) {
          return '<div class="qvd__opt" role="group" aria-label="' + esc(o.name) + '"><span class="qvd__olbl">' + esc(o.name) + (sel[i] ? ': ' + esc(sel[i]) : '') + '</span>' + optValues(i, o).map(function (val) {
            var na = !p.variants.some(function (x) { return x['option' + (i + 1)] === val && x.available && sel.every(function (s, j) { return j === i || x['option' + (j + 1)] === s; }); });
            return '<button type="button" class="qvd__chip' + (na ? ' is-na' : '') + '" data-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (sel[i] === val) + '">' + esc(val) + '</button>';
          }).join('') + '</div>';
        }).join('');
      }
      var price = v ? '<b>' + money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><small>' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off</small>' : '') : '';
      if (!keepGal) {
        body.innerHTML = '<div class="qvd__gal"><div class="qvd__track">' + imgs.map(function (u, k) { return '<img src="' + img(u, 800) + '" alt="' + esc(p.title) + (k ? ' (' + (k + 1) + ')' : '') + '"' + (k ? ' loading="lazy"' : '') + '>'; }).join('') + '</div>' +
          (imgs.length > 1 ? '<button type="button" class="qvd__nav qvd__nav--p" data-nav="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24"><path d="m15 5-7 7 7 7"/></svg></button><button type="button" class="qvd__nav qvd__nav--n" data-nav="1" aria-label="Next photo"><svg viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg></button><div class="qvd__dots">' + imgs.map(function (u, k) { return '<i' + (k ? '' : ' class="is-on"') + '></i>'; }).join('') + '</div>' : '') +
          '</div><div class="qvd__info" data-info></div>';
      }
      body.querySelector('[data-info]').innerHTML =
        '<h3 class="qvd__t">' + esc(p.title) + '</h3><p class="qvd__price">' + price + '</p>' + opts +
        '<div class="qvd__desc">' + (desc(p.description) || '<p>Open the full product page to read more about this piece.</p>') + '</div>' +
        '<a class="qvd__more" href="' + esc(p.url || '/products/' + p.handle) + '">See full product page</a>' +
        '<div class="qvd__cta"><button type="button" class="qvd__add" data-add' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable')) + '</button></div>';
    };

    var load = function (h, cb) {
      if (cache[h]) return cb(cache[h]);
      fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { cache[h] = p; cb(p); }).catch(function () { cb(null); });
    };

    var open = function (h, fromCard) {
      ensure(); handle = h; card = fromCard;
      body.innerHTML = '<div class="qvd__info" style="grid-column:1/-1"><p class="qvd__desc is-load" style="padding:40px 0">Loading...</p></div>';
      if (!dlg.open) dlg.showModal();
      load(h, function (p) {
        if (handle !== h || !dlg.open) return;
        if (!p) { body.innerHTML = '<div class="qvd__info" style="grid-column:1/-1"><p class="qvd__desc">Could not load this piece. <a href="/products/' + esc(h) + '">Open the product page</a>.</p></div>'; return; }
        cur = p;
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        sel = [first.option1, first.option2, first.option3].slice(0, Math.max(1, optNames().length));
        render(false);
      });
    };

    var onClick = function (e) {
      if (e.target === dlg || e.target.closest('[data-qv-close]')) { dlg.close(); return; }
      var nav = e.target.closest('[data-nav]');
      if (nav) { var tr = body.querySelector('.qvd__track'); tr.scrollBy({ left: tr.clientWidth * Number(nav.dataset.nav), behavior: 'smooth' }); return; }
      var chip = e.target.closest('.qvd__chip');
      if (chip) {
        var i = Number(chip.dataset.opt), val = chip.dataset.val, want = sel.slice(); want[i] = val;
        var m = cur.variants.filter(function (v) { return want.every(function (s, j) { return v['option' + (j + 1)] === s; }); })[0]
          || cur.variants.filter(function (v) { return v['option' + (i + 1)] === val && v.available; })[0]
          || cur.variants.filter(function (v) { return v['option' + (i + 1)] === val; })[0];
        if (m) sel = [m.option1, m.option2, m.option3].slice(0, sel.length);
        render(true);
        var v = variantFor();
        if (v && v.featured_image) {
          var at = (cur.images || []).map(base).indexOf(base(v.featured_image.src));
          var tr2 = body.querySelector('.qvd__track'); if (at > -1 && tr2) tr2.scrollTo({ left: tr2.clientWidth * at, behavior: 'smooth' });
        }
        return;
      }
      if (e.target.closest('[data-add]')) {
        var v2 = variantFor(); if (!v2 || !v2.available) return;
        var idInput = card && card.querySelector('input[name="id"]'), btn = card && card.querySelector('.add-to-cart-button');
        dlg.close();
        if (idInput && btn) {
          var orig = idInput.value; idInput.value = v2.id; btn.click();
          setTimeout(function () { idInput.value = orig; }, 2500);
        } else {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v2.id, quantity: 1 }] }) }).then(function () { location.href = '/cart'; });
        }
      }
    };

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qv-open]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      open(b.getAttribute('data-qv-open'), b.closest('.pcc-card, .pfr-card'));
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
